import React from "react";
import styles from "./box.module.css";

const Box = () => {
  return <div className={styles.box_main}></div>;
};

export default Box;
